import React from "react";
import { makeStyles } from "@mui/styles";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';

const useStyles = makeStyles({
  fieldElement: {
    margin: "10px 0 10px 0 !important",
  },
});

const MultiSelect = ({ field, index, form_data, handleFieldChange, is_submitting }) => {
  const classes = useStyles();
  const selected = Array.isArray(form_data[field.name]) ? form_data[field.name] : [];

  const handleChange = (event) => {
    const value = event.target.value;
    handleFieldChange({
      target: {
        id: field.name,
        name: field.name,
        value: typeof value === 'string' ? value.split(',') : value,
      }
    });
  };

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }} className={classes.fieldElement} fullWidth>
      <InputLabel id={`${field.name}-label`}>{field.label}</InputLabel>
      <Select
        id={field.name}
        name={field.name}
        label={field.label}
        multiple
        value={selected}
        onChange={handleChange}
        renderValue={(selectedValues) =>
          field.options
            .filter((option) => selectedValues.includes(option.value))
            .map((option) => option.label)
            .join(', ')
        }
        autoFocus={index === 0}
        variant="outlined"
        disabled={is_submitting}
      >
        {field.options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Checkbox checked={selected.indexOf(option.value) > -1} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiSelect;
